import React, { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'

import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'

import { FilterHeaderCounter, FilterHeaderTitleWrapper, FilterHeaderToggleWrapper, FilterHeaderWrapper } from '../style'

const FilterHeader = ({ isOpen, toggleAccordion, counter, headerTitle, closeAllFilters, closeAccordion }) => {

  useEffect(() => {
    if(closeAllFilters) {
      closeAccordion()
    }
  }, [closeAllFilters])

  return (
    <FilterHeaderWrapper isActive={isOpen} onClick={toggleAccordion}>
      <FilterHeaderTitleWrapper isActive={isOpen}>
        <FormattedMessage id={headerTitle} />
        <FilterHeaderCounter isActive={isOpen}>
          {counter}
        </FilterHeaderCounter>
      </FilterHeaderTitleWrapper>
      <FilterHeaderToggleWrapper isActive={isOpen}>
        <FormattedMessage id='expand' />
        {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
      </FilterHeaderToggleWrapper>
    </FilterHeaderWrapper>
  )
}

export default FilterHeader
